export const translation = {
    "appearance.age": "Alter",
    "appearance.appearance": "Aussehen",
    "appearance.haircolor": "Haarfarbe",
    "appearance.height": "Groesse",
    "appearance.sex": "Geschlecht",
    "appearance.special": "Besonderes / Charakterzüge",
    "appearance.stature": "Statur",
    "appearance.throwing": "Wurf",
    "appearance.weight": "Gewicht",
    "characterAttributes.ch": "Charisma (CH)",
    "characterAttributes.em": "Empathie (EM)",
    "characterAttributes.gd": "Gedächtnis (GD)",
    "characterAttributes.ge": "Geschicklichkeit (GE)",
    "characterAttributes.in": "Intitution (IN)",
    "characterAttributes.ko": "Konstitution (KO)",
    "characterAttributes.lo": "Logik (LO)",
    "characterAttributes.re": "Reaktion (RE)",
    "characterAttributes.sd": "Selbstdisziplin (SD)",
    "characterAttributes.st": "Stärke (ST)",
    "commonAttributes.class": "Beruf",
    "commonAttributes.name": "Name",
    "commonAttributes.player": "Spieler",
    "commonAttributes.race": "Volk",
    "commonAttributes.raceProgression": "Trefferpunkte Progression",
    "defense.armorClass": "Rüstungsklasse (P)",
    "defense.basic": "Grund DB",
    "defense.initiative": "Initiative",
    "defense.total": "DB Total",
    "level.experience": "Erfahrung",
    "level.inspirationPoints": "Schicksalspunkte",
    "level.level": "Stufe",
    "resistance.cold": "WW-Kälte",
    "resistance.essence": "WW-Essenzmagie",
    "resistance.fear": "WW-Furcht",
    "resistance.healingMultiplicator": "Genesungsmultiplikator",
    "resistance.heath": "WW-Hitze",
    "resistance.lead": "WW-Leitmagie",
    "resistance.mental": "WW-Mentalmagie",
    "resistance.poison": "WW-Gift",
    "resistance.sicknes": "WW-Krankheit",
    "resistance.soulforce": "Seelenstärke"
};
export function translate(key) {
    var _a;
    return (_a = translation[key]) !== null && _a !== void 0 ? _a : "??" + key;
}
